import { useContext } from "react"
import {
  Modal,
} from "../ui_new"
import { CheckCircle, Close } from "../../assets/icons"
import { Cancel } from "@mui/icons-material"
import { DocumentsContext, NotificationContext, SingleDocumentContext } from "../../context"


const SingleDocumentSuggestionConfirmationModal = ({
  suggestion,
  action = 'reject',
  onClose,
}) => {
  const { setNotification } = useContext(NotificationContext)
  const { updateDocumentRevision } = useContext(DocumentsContext)
  const { documentId } = useContext(SingleDocumentContext)
  
  const handleCancel = () => {
    onClose()
  }

  const handleConfirm = async () => {
    try {
      const updates = {}
      if(action === 'confirm') {
        updates.acceptSuggestion = suggestion
      } else {
        updates.rejectSuggestion = suggestion
      }
      await updateDocumentRevision(documentId, updates)
      if(action === 'confirm') {
        setNotification({ msg: "Proposition de modification accéptée", type: 'success' })
      } else {
        setNotification({ msg: "Proposition de modification refusée", type: 'success' })
      }
      onClose()
    } catch (error) {
      setNotification({ msg: "Erreur lors de la validation de la proposition de modification", type: 'danger' })
    }
  }

  const title = 'Proposition de modification'

  const descriptionText = action === 'confirm' ? 'Vous êtes sur le point de valider une proposition de modification.' : 'Vous êtes sur le point de refuser une proposition de modification.'

  const questionText = action === 'confirm' ? 'Cette action remplace le contenu dans le mode édition. Êtes-vous sûr de vouloir continuer ?' : 'Cette action est irréversible. Êtes-vous sûr de vouloir continuer ?'

  const cancelLabel = 'Annuler'

  const confirmLabel = 'Valider'

  return (
    <Modal onClose={onClose} className="modal-v2 modal-v2--medium">
      <div className="modal-v2__heading">
        <h2>{title}</h2>
        <div className="buttons-row">
          <button
            className="btn btn--small btn--light btn--border-primary btn--border-radius-sm btn--square"
            onClick={onClose}
          >
            <Close />
          </button>
        </div>
      </div>
      <div className="modal-v2__body">
        <div className="description-box">
        {descriptionText && <p className="share-warning--text">{descriptionText}</p>}
          {questionText && <p className="share-warning--question">{questionText}</p>}
        </div>
        <div className="modal-v2__buttons-footer pb-4">
          {cancelLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-danger"
              onClick={handleCancel}
            >
              <Cancel fontSize="small" />
              {cancelLabel}
            </button>
          )}
          {confirmLabel && (
            <button
              className="modal-v2__btn modal-v2__btn-success"
              onClick={handleConfirm}
            >
              <CheckCircle />
              {confirmLabel}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default SingleDocumentSuggestionConfirmationModal
